<template lang="pug">
  div(data-testid="content-favorite")
    section.content-header
      app-messages(:errorMessages="errors", :successMessages="successes")

      h1 登録待ちの名刺

    section.content
      .panel.panel-default
        loading(v-if="isLoading")
        .table-responsive(v-else-if="list.length > 0")
          table.table.table-striped.table-bordered.bcard-table
            thead
              tr
                th.thd-name 名刺/アップロード日時
                  i.fa.fa-sort-desc.bcard-table-sort-header-icon
                th.td-proxy 修正サービス
                th.thd-exchange 名刺交換日
            tbody
              tr(v-for="item in list", :key="item.id", :class="{'selected': isChecked(item.id)}")
                td.thd-name
                  .row
                    .col-xs-5
                      .bcard-card-queued-card-img-wrap
                        img(
                          :src="app_imgsrc.now_loading",
                          v-src="item.image_url",
                          :alt="item.full_name || item.dispname",
                          :title="item.full_name || item.dispname"
                        )
                    .col-xs-7
                      router-link.text(v-if="isView(item)", :to="{name: 'box-detail', params: {sidPerson: item.sid_person}}")
                        i.fa.bcard-fa-person-private(v-if="item.openflag === '0'" title="非公開")
                        |
                        |
                        | {{item.lang_status}}
                      span.text(v-else)
                        i.fa.bcard-fa-person-private(v-if="item.openflag === '0'" title="非公開")
                        |
                        |
                        | {{item.lang_status}}

                      .progress(:class="'bcard-progress-split-'+getStepCount(item.prog_status)")
                        .progress-bar(role="progressbar", :style="'width:'+getProgress(item.prog_status)+'%;'")

                      //- アップロード日時
                      hr
                      i.fa.fa-fw.fa-mobile(v-if="item.terminal === '2'")
                      i.fa.fa-fw.fa-desktop(v-else)
                      |
                      |
                      | {{item.lang_terminal}} から
                      br
                      | {{item.formatted_uploadtime}}

                td
                  template(v-if="item.input_proxy === app_flag.ON")
                    | 利用する
                  template(v-else)
                    | 利用しない

                td {{item.formatted_exdate}}

        .panel-body.text-center(v-else) 登録待ちの名刺はありません。

      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'QueuedBcards',
  components: {
    AppMessages,
    AppPagination,
    Loading
  },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      // sortOptions: [
      //   {'label': '氏名', 'sort_item': 'name'},
      //   {'label': '会社名', 'sort_item': 'corporate_name'},
      //   {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      // ],

      // 初期条件
      initParams: {
        // ページ条件
        page: { page: 1 }
        // // ソート条件
        // sort: { sort_item: 'name', direction: 'asc' },
        // // 検索条件
        // conds: {}
      }
    }
  },
  created () {
    // サイドメニューから遷移した場合、mixinListで取得しているstoreの条件を上書きする
    if (this.$route.params.init) {
      this.pagination = Object.assign({}, this.initParams.page)
      // this.sort = Object.assign({}, this.initParams.sort)
      // this.conditions = Object.assign({}, this.initParams.conds)
    }

    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @params options
     *    page: ページ条件
     *    sort: ソート条件
     *    conds: 検索条件
     */
    getList (options) {
      const vm = this
      options = options || {}

      let page = options.page || this.pagination.current_page || 1

      let params = {
        // page
        page
      }

      this.clearErrorMessages()
      this.isLoading = true

      // API実行
      this.sendListRequest({
        repo: 'bimage',
        method: 'getQueues',
        params,
        finally () {
          vm.isLoading = false
        }
      })
    },
    isView: function (item) {
      // statusが 4:修正サービス依頼待ち、5:修正サービス依頼中、6:修正サービス中止、7:読取不能、8:一部読取不能、0:完了
      return (
        item.status === '4' ||
        item.status === '5' ||
        item.status === '6' ||
        item.status === '7' ||
        item.status === '8' ||
        item.status === '0'
      )
    },
    isDone: function (item) {
      // statusが 3:画像解析失敗、6:修正サービス中止、7:読取不能、8:一部読取不能、0:完了
      return (
        item.status === '3' ||
        item.status === '6' ||
        item.status === '7' ||
        item.status === '8' ||
        item.status === '0'
      )
    },
    isError: function (item) {
      // statusが'一部読取不能', '読取不能'
      return item.status === '7' || item.status === '8'
    },
    /**
     * int prog_status 2 or 3
     */
    getProgress: function (prog_status) {
      if (prog_status) {
        const prog = prog_status.split('/')
        // CSSのbackground-sizeとあわせるために、1ブロックごとに小数点を繰り上げる
        // 1/2 -> 51px, 2/2 -> 102px
        // 1/3 -> 34px, 2/3 -> 68px, 3/3 -> 102px
        return (Math.floor(100 / prog[1]) + 1) * prog[0]
      }
      return 0
    },
    getStepCount: function (prog_status) {
      if (prog_status) {
        return prog_status.split('/')[1]
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';

  .td-proxy {
    width: 9em;
  }

  .bcard-card-queued-card-img-wrap {
    /*padding: $table-cell-padding;*/
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ebebeb; /* not foundの枠と同じ色 */
    > img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain; /* IE 効かない */
    }
  }

  //------------------------------------------------------------------------------
  // ステップつきプログレスバー
  //------------------------------------------------------------------------------
  .bcard-progress-split-2,
  .bcard-progress-split-3 {
    position: relative;
    border: 1px solid #ccc;
  }
  .bcard-progress-split-2:after,
  .bcard-progress-split-3:after {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    z-index: 1;

    background-image: linear-gradient(
            -90deg,
            rgba(255, 255, 255, .5) 1px,
            rgba(60, 60, 60, .3) 1px,
            transparent 2px,
            transparent 100%
    );
  }

  .bcard-progress-split-2:after {
    background-size: 51%;
  }
  .bcard-progress-split-3:after {
    background-size: 34%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/queued-bcards/Index.vue